import React from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function Login() {
    const [username, setUsername] = React.useState('')
    const [password, setPassword] = React.useState('')
    const [error, setError]       = React.useState('')
    const [loading, setLoading]   = React.useState(false)

    const { login, isAuthenticated } = useAuth()
    const navigate = useNavigate()
    const location = useLocation()
    const from = location.state?.from?.pathname || '/lobby'

    React.useEffect(() => {
        if (isAuthenticated) navigate(from, { replace: true })
    }, [isAuthenticated, navigate, from])

    async function handleSubmit(e) {
        e.preventDefault()
        setError('')
        setLoading(true)
        try {
            await login(username, password)
            navigate(from, { replace: true })
        } catch (err) {
            setError(err.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <main className="flex w-full flex-col items-center justify-start px-5 py-6">
            <div className="bg-white rounded-xl w-full max-w-md shadow-lg overflow-hidden">
                <div className="px-9 py-4">
                <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
                    <label className="flex flex-col gap-1.5 font-semibold text-sm text-bankroll-text">
                        Username
                        <input
                            className="px-3 py-2.5 border border-gray-300 rounded-md font-karla text-base outline-none focus:border-bankroll-primary"
                            type="text"
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            autoComplete="username"
                            autoFocus
                            required
                        />
                    </label>

                    <label className="flex flex-col gap-1.5 font-semibold text-sm text-bankroll-text">
                        Password
                        <input
                            className="px-3 py-2.5 border border-gray-300 rounded-md font-karla text-base outline-none focus:border-bankroll-primary"
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            autoComplete="current-password"
                            required
                        />
                    </label>

                    {error && <p className="text-bankroll-danger text-sm m-0 font-semibold">{error}</p>}

                    <button
                        className="mt-1 py-3 bg-bankroll-primary text-white border-0 rounded-md font-karla text-base font-bold cursor-pointer hover:bg-bankroll-primary-hov disabled:opacity-60 disabled:cursor-default"
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? 'Signing in…' : 'Sign in'}
                    </button>
                </form>

                <p className="mt-5 text-sm text-gray-500 text-center">
                    Don't have an account?{' '}
                    <Link className="text-bankroll-primary font-semibold no-underline hover:underline" to="/register">Register</Link>
                </p>
                </div>
            </div>
        </main>
    )
}
